import DomainResource from './DomainResource';
import merge from 'lodash/merge';
import Reference from './types/Reference';
import Coding from './types/Coding';
import Money from './types/Money';

export default class BN_EOB extends DomainResource {
    static __className = 'BN_EOB';

    __objectStructure = {
        document: Reference,
        fileName: String,
        filePath: String,
        payer: Reference,
        amount: Money,
        paymentMode: Coding,
        paymentReference: String,
        paymentDate: String,
        receivedDate: String,
        remarks: String,
        deleted: Boolean,
        unAppliedBalance: Money,
        createdAt: String,
        updatedAt: String,
        deletedAt: String,
        createdBy: Reference,
        updatedBy: Reference,
        deletedBy: Reference,
    };

    constructor(constructJson, className = 'BN_EOB') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
